let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dgXrW")).then(() => parcelRequire('FmVW1'));